__turbopack_context__.v({
  "animate": "BoxButton-module-scss-module__CQ6o2G__animate",
  "basic": "BoxButton-module-scss-module__CQ6o2G__basic",
  "blue": "BoxButton-module-scss-module__CQ6o2G__blue",
  "button": "BoxButton-module-scss-module__CQ6o2G__button",
  "cornflower": "BoxButton-module-scss-module__CQ6o2G__cornflower",
  "cyan": "BoxButton-module-scss-module__CQ6o2G__cyan",
  "default": "BoxButton-module-scss-module__CQ6o2G__default",
  "default-icon-pl": "BoxButton-module-scss-module__CQ6o2G__default-icon-pl",
  "for-sticky-bottom": "BoxButton-module-scss-module__CQ6o2G__for-sticky-bottom",
  "for-sticky-keyboard": "BoxButton-module-scss-module__CQ6o2G__for-sticky-keyboard",
  "full-width": "BoxButton-module-scss-module__CQ6o2G__full-width",
  "gray": "BoxButton-module-scss-module__CQ6o2G__gray",
  "green": "BoxButton-module-scss-module__CQ6o2G__green",
  "icon": "BoxButton-module-scss-module__CQ6o2G__icon",
  "large": "BoxButton-module-scss-module__CQ6o2G__large",
  "large-icon-pl": "BoxButton-module-scss-module__CQ6o2G__large-icon-pl",
  "loading-icon-area": "BoxButton-module-scss-module__CQ6o2G__loading-icon-area",
  "magenta": "BoxButton-module-scss-module__CQ6o2G__magenta",
  "olive": "BoxButton-module-scss-module__CQ6o2G__olive",
  "orange": "BoxButton-module-scss-module__CQ6o2G__orange",
  "pink": "BoxButton-module-scss-module__CQ6o2G__pink",
  "primary": "BoxButton-module-scss-module__CQ6o2G__primary",
  "red": "BoxButton-module-scss-module__CQ6o2G__red",
  "secondary": "BoxButton-module-scss-module__CQ6o2G__secondary",
  "selected": "BoxButton-module-scss-module__CQ6o2G__selected",
  "small": "BoxButton-module-scss-module__CQ6o2G__small",
  "small-icon-pl": "BoxButton-module-scss-module__CQ6o2G__small-icon-pl",
  "spin": "BoxButton-module-scss-module__CQ6o2G__spin",
  "text": "BoxButton-module-scss-module__CQ6o2G__text",
  "text_white": "BoxButton-module-scss-module__CQ6o2G__text_white",
  "transparent": "BoxButton-module-scss-module__CQ6o2G__transparent",
  "violet": "BoxButton-module-scss-module__CQ6o2G__violet",
  "warning": "BoxButton-module-scss-module__CQ6o2G__warning",
  "yellow": "BoxButton-module-scss-module__CQ6o2G__yellow",
});
